import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ChartFieldLine from './ChartFieldLine';
import Chart from './Chart';
import ChartFieldForm from './ChartFieldForm';
import Modal from '../../../misc/Modal';
import Button from '../../../misc/Button';

import ThemeIcons from '../../../../theme/Icons';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledInputGroup = styled.div`
display: inline-block;
overflow: auto;
`;

const StyledRowWrapper = styled.div`
  margin-bottom: 8px;
  min-width: 570px;
`;

const StyledChartWrapper = styled.div`
  position: relative;
  margin-bottom: 8px;
`;

const StyledButtonWrapper = styled.div`
  display: flex;
`;

class ChartModal extends PureComponent {

  static propTypes = {

    display: PropTypes.bool,
    width: PropTypes.number,

    id: PropTypes.string,
    fieldId: PropTypes.string,
    value: PropTypes.array, //Lines data

    yTitle: PropTypes.string,
    yMin: PropTypes.number,
    yMax: PropTypes.number,
    xTitle: PropTypes.string,
    xMin: PropTypes.number,
    xMax: PropTypes.number,

    onChange: PropTypes.func,
    onLineCreate: PropTypes.func,
    onLineChange: PropTypes.func,
    onLineDelete: PropTypes.func,
    onPointCreate: PropTypes.func,
    onPointChange: PropTypes.func,
    onPointDelete: PropTypes.func,
    onHide: PropTypes.func

  }

  static defaultProps = {
    value: []
  }

  constructor(props) {
    super(props);
    this.state = { displayCoordinatesForm: false };
  }

  filterEmptyPoints = (lines) => {

    return (lines || []).map(line => ({
      ...line,
      points: (line.points || []).filter(p =>
        typeof p.x === 'number' && Number.isFinite(p.x)
        && typeof p.y === 'number' && Number.isFinite(p.y)
      )
    }));

  }

  render() {

    const { displayCoordinatesForm } = this.state;

    const {

      display,

      width,
      theme,

      id,
      fieldId,
      value,
      yTitle,
      yMin,
      yMax,
      xTitle,
      xMin,
      xMax,

      onChange,
      onLineCreate,
      onLineChange,
      onLineDelete,
      onPointCreate,
      onPointChange,
      onPointDelete,

      onHide

    } = this.props;

    return (
      <Modal width={width || 600} height={568} title="Chart" isOpen={display} onHide={onHide} cancelText="Close" onCancel={onHide} overlayStyles={{ zIndex: 10000000000 }}>
        <StyledWrapper data-testid={`${id}-chart-field`}>
          <StyledChartWrapper>
            <Chart
              {...{
                id,
                yTitle,
                yMin,
                yMax,
                xTitle,
                xMin,
                xMax,
                lines: this.filterEmptyPoints(value),
              }}
              primaryMaxHeight={200}
            />
            <StyledButtonWrapper>
              <Button
                styles={{ marginRight: '4px' }}
                text={displayCoordinatesForm ? 'Done Editing' : 'Edit Coordinates'}
                onClick={() => this.setState({ displayCoordinatesForm: !displayCoordinatesForm })}
              />
              <Button
                text="Add Line"
                icon={ThemeIcons.misc.add}
                onClick={onLineCreate}
              />
            </StyledButtonWrapper>
          </StyledChartWrapper>
          {!displayCoordinatesForm ? null : (
            <StyledInputGroup data-testid={`${id}-chart-field-form`}>
              <StyledRowWrapper>
                <ChartFieldForm
                  {...{
                    id,
                    fieldId,
                    yTitle,
                    yMin,
                    yMax,
                    xTitle,
                    xMin,
                    xMax,
                    ...theme
                  }}
                  onChange={(changes) => onChange(changes)}
                />
              </StyledRowWrapper>
            </StyledInputGroup>
          )}
          <StyledInputGroup data-testid={`${id}-chart-field-lines`}>
            {value.map((line, lineIndex) => (
              <StyledRowWrapper key={`${line._id}-${lineIndex}`}>
                <ChartFieldLine
                  {...theme}
                  id={`${id}-${line._id}`}
                  yTitle={yTitle}
                  xTitle={xTitle}
                  lineId={line._id}
                  lineIndex={lineIndex}
                  title={line.title}
                  description={line.description}
                  points={(line.points || []).map(p => ({
                    ...p,
                    x: p.hasOwnProperty('x') ? p.x : null,
                    y: p.hasOwnProperty('y') ? p.y : null,
                  }))}
                  onDelete={onLineDelete}
                  onChange={onLineChange}
                  onPointCreate={onPointCreate}
                  onPointChange={onPointChange}
                  onPointDelete={onPointDelete}
                />
              </StyledRowWrapper>
            ))}
          </StyledInputGroup>
        </StyledWrapper>
      </Modal>
    );

  }

}

export default ChartModal;
